import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERIDIC_TASKS(state, periodicTasks) {
    state.cached = periodicTasks
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPeriodicTasks(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/scheduled_tasks/periodic_task/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERIDIC_TASKS', request)
      return request
    })
  },

  fetchPeriodicTasksOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/scheduled_tasks/periodic_task/tasks_options/${query}`).then((response) => {
      return response.data
    })
  },

  executeManuallyPeriodicTasks(context, url) {
    return axios.get(`${url}execute_manually/`).then((response) => {
      return response.data
    })
  },

  getLiveResultsPeriodicTasks(context, uuid) {
    return axios.get(`${serverUrl}/scheduled_tasks/periodic_task/${uuid}/get_live_results/`).then((response) => {
      return response.data
    })
  },

  fetchPeriodicTasksDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePeriodicTasks(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/scheduled_tasks/periodic_task/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deletePeriodicTasks(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}